// Återställningslänkens token tas ur adressfältet innan någon analys (GA/Umami) hinner
// läsa sidans adress. Den hålls bara i minnet för återställningssidan.
let captured = null;

export const captureResetToken = (loc = window.location, hist = window.history) => {
  if (!loc.pathname.startsWith('/af/aterstall')) return;
  const params = new URLSearchParams(loc.search);
  const token = params.get('token');
  if (!token) return;
  captured = token;
  params.delete('token');
  const query = params.toString();
  hist.replaceState(hist.state, '', `${loc.pathname}${query ? `?${query}` : ''}${loc.hash}`);
};

export const takeResetToken = () => captured;
